<template>
  <div class="main-container thankyou" ref="thankyouContainer">
    <div class="col-12 thankyou-content-holder">
      <div class="thankyou-content-flex" role="alert">
        <div v-html="thankyou.thankYouHeader" class="thankyou-title"></div>
        <div v-html="thankyou.thankYouText" class="thankyou-content"></div>
      </div>
      <div>
        <button @click="$emit('reset-view')">
          <span style="vertical-align: middle">{{ thankyou.backToPoliciesButtonLabel }}&nbsp;&nbsp;</span>
          <svg
            class="icon"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="vertical-align: middle"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8 0.799999L9.8 1.8L15.2 7.3H0V8.7H15.2L9.8 14.2L10.8 15.2L18 8L10.8 0.799999Z"
              fill="currentColor"
            />
          </svg>
          
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  props: {
    thankyou: Object,
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     const thankyouContainer = this.$refs.thankyouContainer;

  //     if (thankyouContainer) {
  //       // ADA - Scroll to the thankyou container
  //       thankyouContainer.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }
  //   });
  // },
};
</script>

<style lang="scss">

@include media-breakpoint-down(sm) {
  #app {
    display:flex;
    flex-direction: column;
    min-height: 100vh;
  }  
  .thankyou {
    
  }
}
.main-container {
  &.thankyou {
    padding: 40px;
    background: var(--backgroundAccent);    
    
    @include media-breakpoint-down(sm) {
      padding: 24px;      
      flex: 1;
      display: flex;
    }
    @include media-breakpoint-up(sm) {
      min-height: 50vh;      
    }
  }
}

.thankyou-content-flex {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  @include media-breakpoint-down(sm) {
    flex: 1;
    row-gap: 24px;
  }  
}

.thankyou-content-holder {
  display: flex;
  flex-direction: column;
  row-gap: 40px;

  button {
    @include primary-btn();    
  }

  @include media-breakpoint-down(sm) {
    flex: 1 !important;
  }  
}

.thankyou-title {
  font-size: 48px;
  line-height: 120%;
  font-weight: 400;
  color: var(--secondaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    font-size: inherit;
    line-height: inherit;
    margin: 0;
  }

  @include media-breakpoint-down(md) {
    font-size: 36px;
  }
  @include media-breakpoint-down(sm) {
    font-size: 24px;
  }
}

.thankyou-content {
  font-size: 24px;
  line-height: 150%;
  color: var(--primaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    margin: 0;    
  }

  @include media-breakpoint-down(sm) {
    font-size: 16px;
  }
}
 @include media-breakpoint-down(sm) {
  button {
    width: 100% !important;
    height: auto !important;
    font-size: 16px !important;
  }
 }
</style>
